export default __webpack_public_path__ + "static/media/hht1_ep20_minisitcom_02.8f41c1f9.png";